import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import './integration.scss';
import intergationLogo from './img/IntegrationLogo.svg'
import updateIcon from './img/UpdateIcon.svg'
import dataSpeedIcon from './img/DataSpeedIcon.svg'
import serviceRequirmentsIcon from './img/ServiceRequirmentsIcon.svg'
import customerSatisfactionIcon from './img/CustomerSatisfactionIcon.svg'

export default function IntegrationPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Integration')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className="form-integration ">
				<div className={'top-block'}>
					<div className={'infopanel'}>
						<div className={'easy-to-integrate'}>
							<div className={'info'}>
								<div className={'easy-to-integrate-title'} ><img src={intergationLogo}></img>EASY TO INTEGRATE</div>
								<div className={'description'}>Simplify and streamline your internal administrative  <br />
									operations through system to system integration via <br />
									Application Programming Interfaces (APIs)</div>
							</div>
						</div>
					</div>
					<div className={'infopanel'}>
						<div className={'options'}>
							<p className={'title'}>Options</p>
							<p className={'topic'}>Custom API</p>
							<p>The Sage Sync API enables you to integrate with any property system.</p>
							<p className={'topic'}>Industry Solutions APIs</p>
							<p>Moraware</p>
							<p>Stone Profit Systems</p>
							<p>Stone Grid USA</p>
							<p>Action Flow</p>
						</div>
					</div>
				</div>
				<div className="bottom-block">
					<div className={'title'}>Benefits</div>
					<div className="benefits">
						<div className={'benefit'}><img src={updateIcon}></img><p>Reduce the number of times your team needs to manually update Sage Sync.</p></div>
						<div className={'benefit'}><img src={dataSpeedIcon}></img><p>Speed the exchange of data and information in real time across systems.</p></div>
						<div className={'benefit'}><img src={serviceRequirmentsIcon}></img><p>Comply with or even exceed retailer service level requirements.</p></div>
						<div className={'benefit'}><img src={customerSatisfactionIcon}></img><p>Improve customer satisfaction.</p></div>
					</div>
				</div>
			</div>


		</React.Fragment>
	)
} 
